// src/pages/public/about/AboutPage.js
import React, { useContext } from 'react';
import Layout from '../../../components/public/common/Layout';
import AboutHeroSection from '../../../components/public/common/AboutHeroSection';
import MissionSection from '../../../components/public/common/MissionSection';
import StorySection from '../../../components/public/common/StorySection';
import WhatWeDoSection from '../../../components/public/common/WhatWeDoSection';
import ValuesSection from '../../../components/public/common/ValuesSection';
import FutureSection from '../../../components/public/common/FutureSection';
import JoinSection from '../../../components/public/common/JoinSection';
import NewsletterSection from '../../../components/public/common/NewsletterSection';
import { useTheme } from '../../../contexts/ThemeContext';

const AboutPage = () => {
  const { theme, toggleTheme } = useTheme();

  // Alternate section themes: dark, light, dark, light, ...
  const sectionThemes = {
    hero: 'dark',
    mission: 'light',
    story: 'dark',
    whatWeDo: 'light',
    values: 'dark',
    future: 'light',
    join: 'dark',
    newsletter: 'light'
  };

  return (
    <Layout>
      <AboutHeroSection theme={sectionThemes.hero} />
      <MissionSection theme={sectionThemes.mission} />
      <StorySection theme={sectionThemes.story} />
      <WhatWeDoSection theme={sectionThemes.whatWeDo} />
      <ValuesSection theme={sectionThemes.values} />
      <FutureSection theme={sectionThemes.future} />
      <JoinSection theme={sectionThemes.join} />
      <NewsletterSection theme={sectionThemes.newsletter} />
    </Layout>
  );
};

export default AboutPage;
